/**
 * Runtime overrides for recipe `page_name` resolution, keyed by URL query
 * param (e.g. `is_lunch` → `lunch`).
 *
 * Populated from CMS `analytics_page_name` via `web_query_param` when the
 * recipe top filter list loads. Cleared on CMS fallback so
 * `RECIPE_PAGE_NAME_MAPPINGS` remains the source of truth.
 */
let cmsRecipePageNameMappings: Record<string, string> = {};

export function setCmsRecipePageNameMappings(
  mappings: Record<string, string>
): void {
  cmsRecipePageNameMappings = { ...mappings };
}

export function clearCmsRecipePageNameMappings(): void {
  cmsRecipePageNameMappings = {};
}

export function getCmsRecipePageNameMappings(): Record<string, string> {
  return cmsRecipePageNameMappings;
}
